import {ChevronRightIcon} from "@pg-design/icons-module";

import * as styles from "./SimpleSliderArrow.module.css";

export const SimpleSliderArrowRight = () => {
    return (
        <div className={styles.sliderArrow}>
            <ChevronRightIcon size="1.2" />
        </div>
    );
};
